<template>
  <div>
    <div class="container-fluid">
      <Breadcrumbs main="Рейтинг" title="История начисления рейтинга за сезон BPL"/>
      <b-card>
        <div class="mb-3">
          <b-btn variant="primary" size="sm" @click="$router.go(-1)">Назад</b-btn>
        </div>

        <div v-if="isLoading" class="loading-wrapper">
          <b-spinner class="spinner"></b-spinner>
        </div>

        <div v-else>
          <div v-if="userInfo" class="mb-3 d-flex flex-wrap align-items-center">
            <div class="mr-4">
              <span class="text-muted">Пользователь:</span>
              <strong class="ml-1">{{ userInfo.username }}</strong>
            </div>
            <div class="mr-4">
              <span class="text-muted">User ID:</span>
              <strong class="ml-1">{{ userInfo.user_id }}</strong>
            </div>
            <div>
              <span class="text-muted">Общий рейтинг:</span>
              <span class="font-weight-bold text-success ml-1">{{ userInfo.total_rating }}</span>
            </div>
          </div>

          <b-table
              responsive
              show-empty
              stacked="md"
              :striped="true"
              :bordered="true"
              :fields="fields"
              :items="tournaments"
              class="mb-4"
          >
            <template v-slot:cell(tournament_id)="{item}">
              {{ item.tournament_id }}
            </template>

            <template v-slot:cell(tournament_name)="{item}">
              {{ item.tournament_name }}
            </template>

            <template v-slot:cell(stages)="{item}">
              <div v-if="item.stages && item.stages.length">
                <div v-for="stage in item.stages" :key="'stage-' + item.tournament_id + '-' + stage.stage_id">
                  {{ stage.stage_name }}
                </div>
              </div>
              <span v-else class="text-muted">—</span>
            </template>

            <template v-slot:cell(stages_rating)="{item}">
              <div v-if="item.stages && item.stages.length">
                <div v-for="stage in item.stages" :key="'stage-rating-' + item.tournament_id + '-' + stage.stage_id">
                  {{ stage.rating }}
                </div>
              </div>
              <span v-else class="text-muted">—</span>
            </template>

            <template v-slot:cell(rating)="{item}">
              <span class="font-weight-bold text-success">{{ item.rating }}</span>
            </template>

            <template v-slot:empty>
              <div class="text-center my-4">
                <h6>Нет данных для отображения</h6>
                <p class="text-muted">У пользователя нет истории начисления рейтинга за выбранный сезон</p>
              </div>
            </template>
          </b-table>

          <div v-if="total > perPage" class="d-flex justify-content-between flex-row-reverse align-items-center">
            <div>
              Показано {{ tournaments.length }} из {{ total }} записей
            </div>
            <b-pagination
                @change="handlePageChange"
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                :disabled="isLoading"
                class="my-0"
            ></b-pagination>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "BplSeasonUserRatingHistory",
  data() {
    return {
      isLoading: false,
      fields: [
        {key: 'tournament_id', label: 'ID турнира', class: 'text-center'},
        {key: 'tournament_name', label: 'Название турнира'},
        {key: 'stages', label: 'Этапы'},
        {key: 'stages_rating', label: 'Рейтинг по этапам', class: 'text-center'},
        {key: 'rating', label: 'Общий рейтинг за турнир', class: 'text-center'},
      ],
    };
  },
  computed: {
    ...mapGetters({
      history: 'getBplSeasonUserRatingHistory',
      total: 'getBplSeasonUserRatingHistoryPaginationTotal',
      pageFromStore: 'getBplSeasonUserRatingHistoryPaginationCurrentPage',
      perPage: 'getBplSeasonUserRatingHistoryPaginationBy',
    }),
    currentPage: {
      get() {
        return this.pageFromStore;
      },
      set() {},
    },
    userId() {
      return Number(this.$route.params.id);
    },
    seasonId() {
      return Number(this.$route.query.season);
    },
    userInfo() {
      return this.history[0] || null;
    },
    tournaments() {
      return this.userInfo?.tournaments || [];
    },
  },
  methods: {
    ...mapActions(['fetchBplSeasonUserRatingHistory']),
    async loadHistory(pageNumber = 1) {
      if (!this.seasonId || !this.userId) {
        console.warn('BplSeasonUserRatingHistory: missing seasonId or userId');
        return;
      }
      try {
        this.isLoading = true;
        await this.fetchBplSeasonUserRatingHistory({
          seasonId: this.seasonId,
          userId: this.userId,
          pageNumber,
        });
      } catch (e) {
        console.error('Error loading BPL season user rating history:', e);
      } finally {
        this.isLoading = false;
      }
    },
    handlePageChange(pageNumber) {
      this.loadHistory(pageNumber);
    },
  },
  created() {
    this.loadHistory(1);
  },
};
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.spinner {
  width: 3rem;
  height: 3rem;
}
</style>
